import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { LoaderService } from "src/app/shared/services/loader-service";
import * as _ from "lodash";
import { OrderTypeService } from "src/app/shared/services/order-type-service";

@Component({
  selector: "app-main",
  templateUrl: "./main.component.html",
  styleUrls: ["./main.component.scss"],
})
export class MainComponent implements OnInit {
  taButton: boolean = true;
  delButton: boolean = true;
  customer;
  constructor(
    private orderTypeService: OrderTypeService,
    public dialog: MatDialog,
    private loader: LoaderService
  ) {}

  async ngOnInit() {
    // this.spinnerService.hide();
    this.loader
      .getCustomerDetails()
      .pipe()
      .subscribe((customer) => {
        this.customer = customer;
      });
  }
  cardHover(event, button) {
    this[button] = event.type === "mouseover" ? false : true;
  }

  chooseDeliveryOrderType() {
    this.orderTypeService.chooseOrderType("delivery", true);
    // this.router.navigate(["/products/all-products"])
  }

  chooseTAOrderType() {
    this.orderTypeService.chooseOrderType("TA", true);
  }
}
